<template>
  <BaseTextViewer :text="editedPatientStory.description" @click:close="$emit('click:close')" />
</template>

<script>
import { mapActions, mapState } from 'vuex';
import BaseTextViewer from '../../components/base/BaseTextViewer';

export default {
  name: 'ViewPatientStoryText',

  components: { BaseTextViewer },

  computed: mapState('patientStory', ['editedPatientStory']),

  created() {
    this.editPatientStory(+this.$route.params.id);
  },

  methods: mapActions('patientStory', ['editPatientStory']),
};
</script>

<style scoped></style>
